<template lang="html">
	<wizard-screen panel-class="omapi-panel__1" :completed="1" :total="5" :nav-next="isDisabled ? 'disabled' : true">
		<h2>What type of site do you have?</h2>
		<div class="omapi-happy-text">Select the option that best describes your website.</div>

		<div class="omapi-radio-group__row">
			<common-selectable-group group-name="usage" :options="typeGroup1" @input="setValue" />

			<common-selectable-group group-name="usage" :options="typeGroup2" @input="setValue" />
		</div>

		<div>
			<input
				v-show="showUsageOther"
				ref="usageOther"
				type="text"
				name="usage_other_text"
				:value="onboardingUsageOtherText"
				class="omapi-input"
				placeholder="Please describe your website"
				@input="setValue"
			/>
		</div>

		<div v-show="hasUsageField" class="omapi-card-content__section">
			<h3>Are you using an email marketing service?</h3>

			<common-selectable-group group-name="email_list" :options="emailGroup" @input="setBoolVal" />

			<select v-show="onboardingEmailList" name="email_service" class="omapi-input__select" @change="setValue">
				<option :selected="'' === onboardingEmailService" value="">Select your provider...</option>
				<option
					v-for="(provider, index) in emailProviders"
					:key="index"
					:selected="provider.slug === onboardingEmailService"
					:value="provider.slug"
				>
					{{ provider.title }}
				</option>
			</select>

			<div>
				<input
					v-show="showEmailOther"
					ref="emailOther"
					type="text"
					name="email_service_other_text"
					:value="onboardingEmailServiceOtherText"
					class="omapi-input"
					placeholder="Enter what email service you are using"
					@input="setValue"
				/>
			</div>
		</div>
		<!--section-->
	</wizard-screen>
</template>

<script lang="js">
import { screen } from './mixins/screen'

export default {
	mixins : [ screen ],
	computed : {
		typeGroup1 () {
			return this.mapToRadios(this.usageMap.slice(0, 3), 'onboardingUsage')
		},
		typeGroup2 () {
			return this.mapToRadios(this.usageMap.slice(3), 'onboardingUsage')
		},
		emailGroup () {
			const use = this.onboardingEmailList
			return [
				{
					label   : 'Yes',
					value   : '1',
					checked : use,
				},
				{
					label   : 'No',
					value   : '0',
					checked : null !== use && !use,
				},
			]
		},
		showUsageOther () {
			return 'other' === this.onboardingUsage
		},
		showEmailOther () {
			return this.onboardingEmailList && 'other' === this.onboardingEmailService
		},
		hasUsageField () {
			if (!this.onboardingUsage) {
				return false
			}

			if ('other' === this.onboardingUsage) {
				return this.onboardingUsageOtherText && this.onboardingUsageOtherText.trim()
			}

			return true
		},
		hasEmailField () {
			if (null === this.onboardingEmailList) {
				return false
			}

			if (this.onboardingEmailList && 'other' === this.onboardingEmailService) {
				return this.onboardingEmailServiceOtherText && this.onboardingEmailServiceOtherText.trim()
			}

			return this.onboardingEmailList
				? Boolean(this.onboardingEmailService)
				: true
		},
		isDisabled () {
			// site (usage), and email list setting are required.
			return !this.hasUsageField || !this.hasEmailField
		},
	},
	watch  : {
		showUsageOther (newValue) {
			if (newValue) {
				this.$nextTick(() => this.$refs.usageOther.focus())
			}
		},
		showEmailOther (newValue) {
			if (newValue) {
				this.$nextTick(() => this.$refs.emailOther.focus())
			}
		},
	},
};
</script>
<style>
.omapi-screen .omapi-panel__1 .omapi-input__select {
	display: block;
	max-width: 100%;
}
</style>
